export const BENEFITS_CARDS_DATA = [
  {
    id: 1,
    path: '/images/benefits-brain.svg',
    alt: 'Benefits brain icon',
    title: 'Machine learning',
    text: 'At vero eos et accusamus et iusto odio dignissimos duciu quili blandit praesentium voluptatum ipsa quae ab illo.',
  },
  {
    id: 2,
    path: '/images/benefits-arrow.svg',
    alt: 'Benefits arrow icon',
    title: 'Embed analytics',
    text: 'At vero eos et accusamus et iusto odio dignissimos duciu quili blandit praesentium voluptatum ipsa quae ab illo.',
  },
  {
    id: 3,
    path: '/images/benefits-key.svg',
    alt: 'Benefits key icon',
    title: 'Access control',
    text: 'At vero eos et accusamus et iusto odio dignissimos duciu quili blandit praesentium voluptatum ipsa quae ab illo.',
  },
  {
    id: 4,
    path: '/images/benefits-graphic.svg',
    alt: 'Benefits graphic icon',
    title: 'Data analytics',
    text: 'At vero eos et accusamus et iusto odio dignissimos duciu quili blandit praesentium voluptatum ipsa quae ab illo.',
  },
];
